import { render, staticRenderFns } from "./AddQuestions.vue?vue&type=template&id=9a7d2c42&scoped=true&"
import script from "./AddQuestions.vue?vue&type=script&lang=js&"
export * from "./AddQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddQuestions.vue?vue&type=style&index=1&id=9a7d2c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7d2c42",
  null
  
)

export default component.exports